import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";

interface SectionActionsProps {
  // ends the buttons' test ids, e.g. "recipient-profile" gives "save-recipient-profile"
  testIdSuffix: string;
  showCancel?: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const SectionActions = ({
  testIdSuffix,
  showCancel = true,
  isSaving,
  onCancel,
  onSave,
}: SectionActionsProps) => {
  const { l10n } = useLocalization();
  return (
    <Row alignItems="center" justifyContent="end">
      {showCancel ? (
        <Row.Item shrink>
          <Button
            kind="negative"
            testId={`cancel-${testIdSuffix}`}
            onClick={onCancel}
            label={l10n.getString("button-cancel")}
          />
        </Row.Item>
      ) : null}
      <Row.Item shrink>
        <Button
          kind="secondary"
          testId={`save-${testIdSuffix}`}
          onClick={onSave}
          disabled={isSaving}
          isLoading={isSaving}
          label={l10n.getString("button-save")}
        />
      </Row.Item>
    </Row>
  );
};

export default SectionActions;
